<template>
  <div class="request-pr-form-hashtag">
    <div class="request-pr-form-hashtag-input">
      <el-input
        placeholder="メンションタグを入力"
        v-model="mentiontagValue"
        @input="suggestTag()"
        @focus="suggest_show = true"
        @blur="suggest_on ? '' : (suggest_show = false) & (suggest_hover = -1)"
        @keydown.up.native="suggestHover('up', 'mention-box')"
        @keydown.down.native="suggestHover('down', 'mention-box')"
        @keydown.enter.native="addMentiontag(suggest_hover)"
        :disabled="mentiontag_loading || report.mention_tag_json.length > 0 || report_id == 'demo'"
      >
        <template slot="prepend">
          <font-awesome-icon :icon="['fal', 'at']" />
        </template>
      </el-input>
      <div class="request-pr-form-suggest" id="mention-box" v-if="suggest_show && mentiontagValue != ''" :class="suggest_tag.length > 8 ? 'scroll' : ''">
        <div
          class="request-pr-form-suggest-box"
          v-for="(suggest, index) in suggest_tag"
          :key="suggest.id"
          v-show="mentiontagValue != '' || suggest_loading"
          :class="suggest_hover == index ? 'hover' : ''"
          @click="addMentiontag(index)"
          @mouseover="suggest_on = true"
          @mouseleave="suggest_on = false"
        >
          <el-image :src="s3BaseUrl + '/profile_picture/' + suggest.user.username + '.jpg'" class="request-pr-form-suggest-image">
            <div slot="error" class="data-table-profile-noimg">
              NO
              <br />IMAGE
            </div>
          </el-image>
          <div>
            <div>
              {{ suggest.user.username }}
              <img src="../../assets/badge.png" style="width:10px; height:10px; margin-left:3px" v-show="suggest.user.is_verified == true" />
            </div>
            <div style="color:#aaa">{{ suggest.user.full_name }}</div>
          </div>
        </div>
        <div class="request-pr-form-suggest-box" v-if="suggest_tag.length == 0 && !suggest_loading">メンションタグが見つかりません</div>
      </div>
      <div v-show="suggest_loading && mentiontagValue" class="request-pr-form-hashtag-loading" :class="create ? 'create' : ''">
        <div class="flex-row">
          候補を取得しています...
          <div class="loader--mini blue"></div>
        </div>
      </div>
      <div class="request-pr-form-hashtag-num">{{ report.mention_tag_json.length }}/1</div>
    </div>
    <div class="request-pr-form-hashtag-wrap">
      <div class="request-pr-form-add-box mention" v-for="(mentiontag, mentiontag_index) in report.mention_tag_json" :key="mentiontag.id">
        <el-image :src="s3BaseUrl + '/profile_picture/' + mentiontag.username + '.jpg'" class="request-pr-form-suggest-image">
          <div slot="error" class="data-table-profile-noimg">
            NO
            <br />IMAGE
          </div>
        </el-image>
        <div>
          <div>
            {{ mentiontag.username }}
            <img src="../../assets/badge.png" style="width:10px; height:10px; margin-left:3px" v-show="mentiontag.badge == '1'" />
          </div>
          <div style="color:#aaa">{{ mentiontag.full_name }}</div>
        </div>
        <div class="flex-space"></div>
        <div>
          <font-awesome-icon icon="times" @click="deleteMentiontag(mentiontag_index)" style="cursor:pointer; padding:5px; font-size:14px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const suggestTagAPI = root + "/api/report/suggest_tag";

export default {
  name: "mentiontagSuggest",
  props: ["create", "report_id"],
  data() {
    return {
      hashtagValue: "",
      mentiontagValue: "",
      report: {
        sns_type: "instagram",
        influencer: "",
        influencer_list: [],
        hash_tag_json: [],
        mention_tag_json: [],
        start_at: "",
        list_value: "",
      },
      suggest_influencer: [],
      suggest_list: [],
      suggest_tag: [],
      suggest_loading: false,
      suggest_show: false,
      suggest_hover: -1,
      suggest_on: false,
      create_loading: false,
      mentiontag_loading: false,
      enter_on: false,
      requestId: 0,
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  mounted() {},
  methods: {
    suggestHover(type, position) {
      if (type == "up") {
        if (this.suggest_hover == -1) {
          this.suggest_hover += 0;
        } else {
          this.suggest_hover -= 1;
        }
      } else if (type == "down") {
        if (position == "influencer-box") {
          if (this.suggest_hover == this.suggest_influencer.length - 1) {
            this.suggest_hover += 0;
          } else {
            this.suggest_hover += 1;
          }
        } else if (position == "list-box") {
          if (this.suggest_hover == this.suggest_list.length - 1) {
            this.suggest_hover += 0;
          } else {
            this.suggest_hover += 1;
          }
        } else if (position == "mention-box") {
          if (this.suggest_hover == this.suggest_tag.length - 1) {
            this.suggest_hover += 0;
          } else {
            this.suggest_hover += 1;
          }
        }
      }
      if (position == "list-box") {
        var suggest_position = 51;
      } else {
        suggest_position = 59;
      }
      var target = document.getElementById(position);
      target.scrollTop = (this.suggest_hover - 5) * suggest_position;
    },
    suggestTag() {
      this.suggest_loading = true;
      this.suggest_show = true;
      this.suggest_tag = [];
      this.suggest_hover = -1;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.axios
        .get(suggestTagAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            query: this.mentiontagValue,
          },
        })
        .then((response) => {
          this.suggest_tag = response.data.users;
          this.suggest_loading = false;
        });
    },
    addMentiontag(index) {
      if (index > -1) {
        this.enter_on = true;
        if (this.report.mention_tag_json.length > 0) {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "メンションタグは1件までしか登録できません",
          });
        } else {
          this.mentiontag_loading = true;
          this.report.mention_tag_json.push(this.suggest_tag[index].user);
          this.$emit("syncMentiontag", this.report.mention_tag_json);
          this.mentiontag_loading = false;
          this.mentiontagValue = "";
        }
        setTimeout(() => {
          this.enter_on = false;
        }, 200);
      }
    },
    deleteMentiontag(index) {
      this.report.mention_tag_json.splice(index, 1);
      this.$emit("syncMentiontag", this.report.mention_tag_json);
    },
  },
  watch: {},
  filters: {},
};
</script>
